import { AutoMap } from '@automapper/classes';

export class MeanOfPreventionEntity {
    Id?: number;
    @AutoMap()
    Name!: number;
}
